import { apiSlice } from '../apiSlice';
import { SuccessResponse, Paginated } from '../DTO/common.interface';
import {
	EditRegionRequest,
	EditUnitRequest,
	FieldFilter,
	SystemDictTypeDTO,
} from '../DTO/field-option/fieldOption.interface';

export const fieldOption = apiSlice.injectEndpoints({
	endpoints: (builder) => ({
		getFieldOptionList: builder.query<
			SuccessResponse<Paginated<SystemDictTypeDTO>>,
			FieldFilter
		>({
			query: (body) => ({
				url: `/web/dict/type/page`,
				method: 'POST',
				body,
			}),
		}),
		getFieldOptionUnitList: builder.query<
			SuccessResponse<Paginated<any>>,
			FieldFilter
		>({
			query: (body) => ({
				url: `/web/branch/page`,
				method: 'POST',
				body,
			}),

			providesTags: ['FieldOptionUnitList'],
		}),
		getFieldOptionUnitDetail: builder.query<
			SuccessResponse<Paginated<any>>,
			string
		>({
			query: (id) => ({
				url: `/web/branch/${id}`,
				method: 'GET',
			}),
		}),
		editFieldOptionUnitDetail: builder.mutation<
			SuccessResponse<any>,
			EditUnitRequest
		>({
			query: (body) => ({
				url: `/web/branch/${body.id}`,
				method: 'PUT',
				body,
			}),
			invalidatesTags: ['FieldOptionUnitList'],
		}),
		createFieldOptionUnitDetail: builder.mutation<
			SuccessResponse<any>,
			EditUnitRequest
		>({
			query: (body) => ({
				url: `/web/branch`,
				method: 'POST',
				body,
			}),
			invalidatesTags: ['FieldOptionUnitList'],
		}),
		updateFieldOptionUnitDetailStatus: builder.mutation<
			SuccessResponse<any>,
			any
		>({
			query: (body) => ({
				url: `/web/branch/status`,
				method: 'PUT',
				body,
			}),
		}),
		updateFieldOptionUnitDetailOrder: builder.mutation<
			SuccessResponse<any>,
			string[]
		>({
			query: (body) => ({
				url: `/web/branch/re-order`,
				method: 'PUT',
				body,
			}),
		}),

		getFieldOptionRegionList: builder.query<
			SuccessResponse<Paginated<any>>,
			FieldFilter
		>({
			query: (body) => ({
				url: `/web/area/page`,
				method: 'POST',
				body,
			}),

			providesTags: ['FieldOptionRegionList'],
		}),
		getFieldOptionRegionDetail: builder.query<SuccessResponse<any>, string>({
			query: (id) => ({
				url: `/web/area/${id}`,
				method: 'GET',
			}),
		}),
		editFieldOptionRegionDetail: builder.mutation<
			SuccessResponse<any>,
			EditRegionRequest
		>({
			query: (body) => ({
				url: `/web/area/${body.id}`,
				method: 'PUT',
				body,
			}),
			invalidatesTags: ['FieldOptionRegionList'],
		}),
		createFieldOptionRegionDetail: builder.mutation<
			SuccessResponse<any>,
			EditRegionRequest
		>({
			query: (body) => ({
				url: `/web/area`,
				method: 'POST',
				body,
			}),
			invalidatesTags: ['FieldOptionRegionList'],
		}),
		updateFieldOptionRegionDetailStatus: builder.mutation<
			SuccessResponse<any>,
			any
		>({
			query: (body) => ({
				url: `/web/area/status`,
				method: 'PUT',
				body,
			}),
		}),

		updateFieldOptionRegionDetailOrder: builder.mutation<
			SuccessResponse<any>,
			string[]
		>({
			query: (body) => ({
				url: `/web/area/re-order`,
				method: 'PUT',
				body,
			}),
		}),

		getFieldOptionCommonList: builder.query<
			SuccessResponse<Paginated<any>>,
			FieldFilter
		>({
			query: (body) => ({
				url: `/web/dict/page`,
				method: 'POST',
				body,
			}),

			providesTags: ['FieldOptionCommonList'],
		}),
		getFieldOptionCommonDetail: builder.query<
			SuccessResponse<any>,
			string | number
		>({
			query: (type) => ({
				url: `/web/dict/type/${type}`,
				method: 'GET',
			}),
		}),
		getFieldOptionCommonIdDetail: builder.query<SuccessResponse<any>, string>({
			query: (id) => ({
				url: `/web/dict/${id}`,
				method: 'GET',
			}),
		}),
		editFieldOptionCommonDetail: builder.mutation<
			SuccessResponse<any>,
			EditRegionRequest
		>({
			query: (body) => ({
				url: `/web/dict/${body.id}`,
				method: 'PUT',
				body,
			}),
			invalidatesTags: ['FieldOptionCommonList'],
		}),
		createFieldOptionCommonDetail: builder.mutation<
			SuccessResponse<any>,
			EditRegionRequest
		>({
			query: (body) => ({
				url: `/web/dict`,
				method: 'POST',
				body,
			}),
			invalidatesTags: ['FieldOptionCommonList'],
		}),
		updateFieldOptionCommonDetailStatus: builder.mutation<
			SuccessResponse<any>,
			any
		>({
			query: (body) => ({
				url: `/web/dict/status`,
				method: 'PUT',
				body,
			}),
			invalidatesTags: ['FieldOptionCommonList'],
		}),
		updateFieldOptionCommonDetailOrder: builder.mutation<
			SuccessResponse<any>,
			string[]
		>({
			query: (body) => ({
				url: `/web/dict/re-order`,
				method: 'PUT',
				body,
			}),
		}),
	}),
});

export const {
	useGetFieldOptionListQuery,
	useGetFieldOptionUnitListQuery,
	useGetFieldOptionUnitDetailQuery,
	useEditFieldOptionUnitDetailMutation,
	useCreateFieldOptionUnitDetailMutation,
	useUpdateFieldOptionUnitDetailStatusMutation,
	useUpdateFieldOptionUnitDetailOrderMutation,
	useGetFieldOptionRegionListQuery,
	useGetFieldOptionRegionDetailQuery,
	useEditFieldOptionRegionDetailMutation,
	useCreateFieldOptionRegionDetailMutation,
	useUpdateFieldOptionRegionDetailStatusMutation,
	useUpdateFieldOptionRegionDetailOrderMutation,
	useGetFieldOptionCommonListQuery,
	useGetFieldOptionCommonDetailQuery,
	useGetFieldOptionCommonIdDetailQuery,
	useEditFieldOptionCommonDetailMutation,
	useCreateFieldOptionCommonDetailMutation,
	useUpdateFieldOptionCommonDetailStatusMutation,
	useUpdateFieldOptionCommonDetailOrderMutation,
} = fieldOption;
